export enum Category {
  Carnes = 'carnes',
  Congelados = 'congelados',
  Aves = 'aves',
  Frios = 'frios',
  Mercearia = 'mercearia',
  Temperos = 'temperos',
  Kits = 'kits',
}
